<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.99984" cy="7.99996" r="6.58333" :stroke="color" stroke-width="1.5" />
    <path d="M6 6.2288C6.14786 5.80053 6.43972 5.43941 6.82387 5.20938C7.20802 4.97935 7.65968 4.89526 8.09885 4.97201C8.53802 5.04876 8.93636 5.2814 9.22332 5.62871C9.51027 5.97602 9.66733 6.41561 9.66666 6.8696C9.66666 8.15119 7.77987 8.79199 7.77987 8.79199" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.83057 11.3555H7.83743" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#727D94'
        },
    }
}
</script>
